import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet, RouterModule } from '@angular/router';
import { APP_BASE, AppBase } from './app-base';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [{ provide: APP_BASE, useExisting: AppComponent }],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends AppBase {}
